var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "a-row",
        { attrs: { gutter: 8 } },
        [
          _c(
            "a-col",
            { staticStyle: { "margin-bottom": "4px" }, attrs: { span: 24 } },
            [
              _c("j-vxe-table", {
                attrs: {
                  toolbar: "",
                  "row-number": "",
                  "row-selection": "",
                  "click-select-row": "",
                  "highlight-current-row": "",
                  "radio-config": { highlight: false },
                  "checkbox-config": { highlight: false },
                  height: 340,
                  loading: _vm.table1.loading,
                  columns: _vm.table1.columns,
                  dataSource: _vm.table1.dataSource,
                  pagination: _vm.table1.pagination
                },
                on: {
                  pageChange: _vm.handleTable1PageChange,
                  selectRowChange: _vm.handleTable1SelectRowChange
                }
              })
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c("j-vxe-table", {
                attrs: {
                  toolbar: "",
                  "row-number": "",
                  "row-selection": "",
                  "click-select-row": "",
                  "highlight-current-row": "",
                  "radio-config": { highlight: false },
                  "checkbox-config": { highlight: false },
                  height: 340,
                  loading: _vm.table2.loading,
                  columns: _vm.table2.columns,
                  dataSource: _vm.table2.dataSource,
                  pagination: _vm.table2.pagination
                },
                on: {
                  pageChange: _vm.handleTable2PageChange,
                  selectRowChange: _vm.handleTable2SelectRowChange
                }
              })
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { span: 12 } },
            [
              _c("j-vxe-table", {
                attrs: {
                  toolbar: "",
                  "row-number": "",
                  "row-selection": "",
                  height: 340,
                  loading: _vm.table3.loading,
                  columns: _vm.table3.columns,
                  dataSource: _vm.table3.dataSource,
                  pagination: _vm.table3.pagination
                },
                on: { pageChange: _vm.handleTable3PageChange }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }